/** Pointer move/cancel handlers for long-press detection. */
import { useCallback } from 'react';

export function useLongPressMoveCancelHandlers({
  moveThreshold,
  timerRef,
  startPointRef,
  isMovementExceededRef,
}) {
  const onPointerMove = useCallback(
    (e) => {
      if (timerRef.current) {
        const dx = Math.abs(e.clientX - startPointRef.current.x);
        const dy = Math.abs(e.clientY - startPointRef.current.y);
        if (dx > moveThreshold || dy > moveThreshold) {
          isMovementExceededRef.current = true;
          clearTimeout(timerRef.current);
        }
      }
    },
    [moveThreshold, timerRef, startPointRef, isMovementExceededRef],
  );

  const onPointerCancel = useCallback(() => {
    clearTimeout(timerRef.current);
  }, [timerRef]);

  return { onPointerMove, onPointerCancel };
}
